import styled from "styled-components";

export const VendasEmpresaContainer = styled.div`
  margin-top: 15px;
  font-family: Akrobat SemiBold;
  background-color: #f9fbfb;
`;
export const VendasEmpresaContainerText = styled.div`
  background-color: #cf7576;
  padding: 15px 0;
  h1 {
    color: #fff;
    font-size: 23px;
    font-weight: 400;
    text-align: center;
  }
`;
export const ContentFilter = styled.div`
  display: flex;
  font-family: Akrobat SemiBold;
  justify-content: center;
  background-color: #f0f4f5;
  padding: 20px 0;
  color: #cf7576;
`;
export const ContentFilterSelect = styled.div`
  background-color: #fff;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
  padding: 0 10px;
  font-size: 13px;
  margin: 0 10px;
  display: flex;
  align-items: center;

  input {
    border: 0;
    color: #919aae;
  }
`;
export const ButtonSelect = styled.button`
  background-color: #cf7576;
  color: #fff;
  border: none;
  border-radius: 5px;
  font-family: "Akrobat";

  padding: 0 13px;
  height: 50px;
  width: 6rem;
`;
export const TablesGrid = styled.div`
  flex-direction: column;
  font-family: "Akrobat";
  margin-top: 15px;
`;
export const TablesHighlights = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
`;
export const TablesHighlightsItem = styled.div`
  background-color: #cf7576;
  color: #fff;
  width: 25%;
  height: 60px;
  margin-right: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 20px;
  border-radius: 5px;

`;
export const TablesHighlightsItemName = styled.p`
  font-size: 20px;
  font-weight: 300;
  strong {
    letter-spacing: 0.08rem;
  }
`;
